document.addEventListener("DOMContentLoaded", function () {

  const TARGET_ID = "shopify-section-template--26884326883668__multicolumn_qaABTR";

  function scrollToTarget() {
    const target = document.getElementById(TARGET_ID);
    if (!target) return;

    // gestiamo header sticky
    const header = document.querySelector("sticky-header, header");
    const offset = header ? header.offsetHeight : 0;

    const top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      offset -
      10;

    window.scrollTo({
      top: top,
      behavior: "smooth",
    });
  }

  // intercettiamo click su QUALSIASI bottone/link con testo "Scopri come funziona"
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest("a, button");
    if (!btn) return;

    const text = btn.innerText?.toLowerCase() || "";

    if (text.includes("scopri come funziona")) {
      e.preventDefault();
      scrollToTarget();
    }
  });
});
